import SesionNoDisponible from './../pages/sesion-no-disponible.vue';
import UsuarioActualizado from './usuarioActualizado.js';
import { crearBarrera, textoDelFallo, TOPE_BARRERA_MS } from './barreraRuta.js';

/**
 * #65 · Barrera de entrada de las pantallas que deciden algo con los permisos del usuario.
 *
 * QUÉ GARANTIZA (decisión de diseño de Donchurru, 01/10/2026 en la incidencia #65):
 *
 * Cuando la pantalla se monta, los permisos con los que se ha decidido qué enseñar vienen del
 * `Usuario.me()` de ESTA carga, y viajan como `prop` ya resueltos. No hay ventana en la que la
 * pantalla decida con el menú de la sesión anterior y la corrija más tarde, porque no hay «más
 * tarde»: si el usuario todavía no ha llegado, la pantalla no se monta.
 *
 * Y mientras está pendiente o si falla, no se aceptan los permisos antiguos: se enseña
 * `sesion-no-disponible.vue` con su botón de reintentar. Dar por buenos los de la sesión anterior
 * es exactamente el fallo que esto cierra —enseñar la ficha entera de un compañero a quien ya no
 * tiene el módulo, o quitársela a quien sí—.
 *
 * POR QUÉ EN LA RUTA Y NO VIGILANDO DESDE CADA PANTALLA:
 *
 * La forma anterior era `RoutesUtils.alCargarElMenu`: resolver con lo que hubiera y revisarlo
 * cuando apareciera el menú. Tenía dos agujeros que no se arreglan afinándola:
 *
 *  1. `Utils.getMenu()` contesta al instante con el menú guardado en `localStorage` cuando
 *     `app.data.user` aún está vacío, así que la vigilancia terminaba antes de empezar.
 *  2. `app.vue#startSession` no refrescaba el usuario si ya había uno guardado, así que el menú
 *     nuevo no llegaba nunca y la vigilancia expiraba sin nada que ver.
 *
 * Son el mismo fallo de fondo —tomar lo persistido por una respuesta— y por eso la pregunta se
 * hace una sola vez, en `usuarioActualizado.js`, y se contesta antes de montar nada.
 *
 * REUTILIZA EL CONTRATO DE ARRANQUE DE LA #49, no otro: el tope de tiempo, el descarte de las
 * respuestas de una navegación abandonada y el cerrojo del router son las piezas de
 * `barreraRuta.js`, las mismas que usa la barrera del calendario.
 */

/**
 * @param {Function} decidirPantalla `(routeTo, usuario) => {component, props}`. Se llama con el
 *        usuario fresco ya disponible, así que dentro se puede preguntar por los permisos
 *        (`RoutesUtils.tieneAcceso`, `PermisosEmpleados…`) con la certeza de que contestan con el
 *        menú de ahora y no con el de la sesión anterior.
 */
export function conUsuarioActualizado(decidirPantalla) {
    return crearBarrera({
        tope: TOPE_BARRERA_MS,
        pedir: function() {
            return UsuarioActualizado.esperar();
        },
        alResolver: function(usuario, routeTo) {
            return decidirPantalla(routeTo, usuario);
        },
        alFallar: function(e, routeTo) {
            return {
                component: SesionNoDisponible,
                props: {
                    url: routeTo.url,
                    motivo: textoDelFallo(e, 'No se han podido comprobar tus permisos.')
                }
            };
        }
    });
}

export default conUsuarioActualizado;
